import axiosInstance from "../Interceptors/ResponseInterceptor";

// /api/stakeholder-mapping/stakeholders/add
export const createStakeHolderBySiteId = async (id, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      let postData = { SiteID: id, ...data };
      const response = await axiosInstance.post(
        `/api/stakeholder-mapping/stakeholders/add`,
        postData
      );
      //
      resolve(response.data);
    } catch (error) {
      console.error("Error in createPassword:", error);
      reject(error);
    }
  });
};

export const deleteStakeholderById = async (stakeholderId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.delete(
        `/api/stakeholder-mapping/stakeholders/${stakeholderId}`
      );
      resolve(response.data);
    } catch (error) {
      console.error("Error deleting stakeholder:", error);
      reject(error);
    }
  });
};

export const getStakeholdersByCompany = async (company) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(
        `/stakeholders/company/${company}`
      );
      //
      resolve(response.data);
    } catch (error) {
      console.error("Error in getLocationByCity:", error);
      reject(error);
    }
  });
};
